module.exports = __webpack_public_path__ + "img/illustration_es.f159ca4e.png";